import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Button from '../../../../components/UI/button/button';

import Instructions from './instructions';
import DateAndHour from './date-and-hour';
import Loading from './loading';
import ShowCode from './show-code';

import { getReleaseCodeToOfflineRelease } from '../../../../store/actions/customer-actions';

import DateHelper from '../../../../utils/helper/date-helper';
import { scrollToTop } from '../../../../utils/helper/page-behavior-helper';

import styles from './styles.module.scss';

function OfflineUnlock({ chargeBuyerCompany, companiesData }) {
  const [visibleView, setVisibleView] = useState('');
  const [countdown, setCountdown] = useState(0);
  const [date, setDate] = useState('');
  const [hour, setHour] = useState('');
  const [code, setCode] = useState('');

  const device = useSelector((state) => state?.customer?.device);
  const dispatch = useDispatch();

  const DISABLED_CONTINUE_BUTTON = visibleView === 'loading' || (visibleView === 'dateAndHour' && (!date || !hour));

  useEffect(() => {
    if (!countdown) {
      cleanAllValues();
      return;
    }

    const intervalId = setInterval(() => {
      setCountdown(countdown - 1);
    }, 60000);

    return () => clearInterval(intervalId);
  }, [countdown]);

  useEffect(() => {
    scrollToTop();
  }, [visibleView]);

  function cleanAllValues() {
    setVisibleView('');
    setCountdown(0);
  }

  function renderContentView() {
    switch (visibleView) {
      case 'dateAndHour':
        return <DateAndHour date={date} setDate={setDate} hour={hour} setHour={setHour} />;
      case 'loading':
        return <Loading />;
      case 'showCode':
        return <ShowCode setCountdown={setCountdown} code={code} />;
      default:
        return (
          <Instructions
            title={chargeBuyerCompany?.title || companiesData[0]?.title}
            description={chargeBuyerCompany?.description() || companiesData[0]?.description()}
            selfService={chargeBuyerCompany?.selfService || companiesData[0]?.selfService}
            onlineChat={chargeBuyerCompany?.onlineChat || companiesData[0]?.onlineChat}
            appDescription={chargeBuyerCompany?.appDescription() || companiesData[0]?.appDescription()}
            email={chargeBuyerCompany?.email || companiesData[0]?.email}
            phoneNumber={chargeBuyerCompany?.phoneNumber || companiesData[0]?.phoneNumber}
            onClickPhoneNumber={chargeBuyerCompany?.onClickPhoneNumber || companiesData[0]?.onClickPhoneNumber}
            whatsapp={chargeBuyerCompany?.whatsapp || companiesData[0]?.whatsapp}
            onClickWhatsapp={chargeBuyerCompany?.onClickWhatsapp || companiesData[0]?.onClickWhatsapp}
          />
        );
    }
  }

  function goBack() {
    if (visibleView === 'showCode') {
      return setVisibleView('dateAndHour');
    }

    if (visibleView === 'dateAndHour') {
      return setVisibleView('');
    }
  }

  function onContinueClicked() {
    if (!visibleView) {
      return setVisibleView('dateAndHour');
    }

    if (visibleView === 'dateAndHour') {
      return sendDateAndHour();
    }
  }

  function sendDateAndHour() {
    setVisibleView('loading');

    setTimeout(() => {
      dispatch(getReleaseCodeToOfflineRelease(hour, DateHelper.displayToDate(date), device)).then((response) => {
        if (response.payload.code) setCode(response.payload.code);
        setVisibleView('showCode');
      });
    }, 2000);
  }

  return (
    <div className={styles.container}>
      <div>
        <div className={styles.header}>
          <img alt="SuperSim logo" src="/image/logo.png" width="120px" />
        </div>

        <div className={!visibleView ? 'hidden' : styles.navigationBar}>
          <FontAwesomeIcon onClick={goBack} icon={faChevronLeft} className={styles.icon} />

          <p>Desbloqueio offline</p>

          <div />
        </div>

        <div className={`${styles.content} d-flex justify-content-center align-items-center`}>
          {renderContentView()}
        </div>
      </div>

      <div className={styles.footer}>
        {!visibleView && <p>*Caso seu celular esteja bloqueado, clique abaixo:</p>}

        {visibleView === 'showCode' ? (
          <Button
            height="58px"
            style={{
              boxShadow: '0px 10px 19px 1px rgba(177, 192, 220, 0.246377)',
              background: '#fff',
              color: '#ED2E45',
            }}
            rounded
            onClick={!code && visibleView === 'showCode' ? () => setVisibleView('') : null}
          >
            {!code && visibleView === 'showCode' ? 'Tentar novamente' : `Código expira em ${countdown} min...`}
          </Button>
        ) : (
          <Button
            background="#ED2E45"
            height="58px"
            rounded
            onClick={onContinueClicked}
            disabled={DISABLED_CONTINUE_BUTTON}
          >
            Desbloqueio offline
          </Button>
        )}
      </div>
    </div>
  );
}

export default OfflineUnlock;
